import { Argument } from "../argument.model";


export class Softskill {
    id: string;
    name: string;
    readableName: string;
    description: string;
    active: boolean;
    //softskillCategory: SoftskillCategoryModel;
    imageUrl: string;
    imageMiniUrl: string;
    arguments: Array<Argument>;
    defaultAgendaColor: string;
}